// Self-contained category map for the search feature.
// Maps homepage filter display names to actual database slugs.

// All keys are normalized to lowercase kebab-case for consistent lookup.
export const SEARCH_CATEGORY_MAP: Record<string, string[]> = {
  // Display categories (normalized to kebab-case)
  'tests-and-scans': ['radiology'],
  'primary-care': ['general-practitioner'],
  'surgical-speciality': [
    'general-surgery',
    'plastic-surgery',
    'trauma-and-orthopaedics',
    'neurosurgery',
  ],

  // Canonical route mappings to DB slugs
  'emergency-clinic-london': ['general-practitioner'],
  'aesthetics-clinic': ['aesthetics'],
  'audiology-hearing-test-battersea-london': ['audiology'],
  'blood-test': ['general-practitioner'],
  'bone-scan': ['radiology'],
  'private-breast-clinic': ['oncoplastic-breast-surgery'],
  'dental-services': ['general-practitioner'],
  dietetics: ['general-practitioner', 'dietetics'],
  exroid: ['general-surgery'],
  fertility: ['gynaecology-and-obstetrics', 'womens-health'],
  'female-fertility': ['gynaecology-and-obstetrics', 'womens-health'],
  'gastric-alimetry': ['gastroenterology-and-hepatology'],
  'private-gp': ['general-practitioner'],
  'hip-replacement-and-knee-replacement': ['trauma-and-orthopaedics'],
  arthrosamid: ['trauma-and-orthopaedics'],
  'liver-health-liver-scans': ['gastroenterology-and-hepatology', 'radiology'],
  'liver-health-fibroscan': ['gastroenterology-and-hepatology', 'radiology'],
  'menopause-clinic': ['gynaecology-and-obstetrics', 'womens-health'],
  menopause: ['gynaecology-and-obstetrics', 'womens-health'],
  'mole-mapping': ['dermatology'],
  psychiatry: ['psychiatry', 'psychological-coaching'],
  'childrens-health-paediatrics': ['general-practitioner'],
  'private-paediatrician': ['general-practitioner'],
  'lumps-and-bumps': ['general-surgery', 'plastic-surgery'],
  'trauma-and-orthopaedics-lower-limb': ['trauma-and-orthopaedics'],
  'trauma-and-orthopaedics-upper-limb': ['trauma-and-orthopaedics'],
  trt: ['general-practitioner'],
  ultrasound: ['radiology'],
  'urology-and-andrology': ['prostate-symptoms'],

  // Additional page route → DB slug mappings (only where route ≠ DB slug)
  'breast-clinic': ['oncoplastic-breast-surgery'],
  geriatrics: ['elderly-medicine'],
  'gynaecology-and-obstetrics': ['gynaecology'],
  haematology: ['haemato-oncology', 'blood-disorders', 'blood-cancer'],
  maxillofacial: ['oral-surgery'],
  neurosurgery: ['spinal-surgery', 'back-surgery', 'neuro-oncology'],
  'sexual-health': ['sexual-function'],
  physiotherapy: ['physiotherapy', 'musculoskeletal-physiotherapy'],
};

function normalizeCategory(category: string): string {
  return category
    .toLowerCase()
    .trim()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// Returns the mapped slugs for a given display name, or the original name if no mapping exists.
export function mapSearchCategoryToSlugs(category: string): string[] {
  const normalized = normalizeCategory(category);
  return SEARCH_CATEGORY_MAP[normalized] ?? [category];
}
